import { gql, useApolloClient } from '@apollo/client'
import { logger } from 'lib/logger'

import { AlgoliaProfileHitProps } from 'components/SearchResults/AlgoliaProfileHitProps'
import useMarketId from 'hooks/useMarketId'

const useWriteSearchHitToCache = (): {
  writeSearchHitToCache: (hit: AlgoliaProfileHitProps) => void
} => {
  const marketId = useMarketId()
  const client = useApolloClient()

  const writeSearchHitToCache = (hit: AlgoliaProfileHitProps) => {
    if (hit.slug && hit.profileName && hit.profilePictureId && hit.profileId) {
      try {
        client.writeQuery({
          query: gql`
            query WriteProfile($marketId: ID!, $slug: String!) {
              market(id: $marketId) {
                profile(slug: $slug) {
                  id
                  slug
                  name
                  title
                  profilePicture {
                    id
                    cardUrl: url(format: { width: 265, height: 458, fit: crop })
                  }
                }
              }
            }
          `,
          data: {
            market: {
              profile: {
                id: hit.profileId,
                slug: hit.slug,
                name: hit.profileName,
                title: hit.profileTitle,
                __typename: 'PublicProfile',
                profilePicture: {
                  id: hit.profilePictureId,
                  cardUrl: hit.profilePictureUrl,
                  __typename: 'ImageAttachment',
                },
              },
            },
          },
          variables: {
            marketId,
            slug: hit.slug,
          },
        })
      } catch (err) {
        logger.info('Could not write search result to apollo cache', err)
      }
    }
  }

  return { writeSearchHitToCache }
}

export default useWriteSearchHitToCache
